import React, { Component } from 'react';
import PSPDFKit from '../pspdfkit';
import {
  getOrder,
  getForms,
  getCampaignFormData,
  getDocumentArrayBuffer
} from '../../api/choiceforms';
/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

export class ChoiceViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedForms: {}
    };
  }

  async componentDidMount() {
    console.log(this.props.match.params);
    const orderid = this.props.match.params.superid;
    const client = this.props.match.params.client;
    const formid = this.props.match.params.formid;
    let parsedOrderid = orderid;
    let refKey = '';
    let taskId = '';
    let studentId = '';
    if (orderid.indexOf('_reference') !== -1 && orderid.split('_').length > 2) {
      parsedOrderid = orderid.split('_')[0];
      refKey = orderid.split('_')[2];
    } else if (orderid.indexOf('_campaign') !== -1) {
      taskId = orderid.split('_')[0];
      studentId = orderid.split('_')[2];
    }

    let results;
    if (taskId === '') {
      results = await getOrder(client, parsedOrderid);
    } else {
      results = await getCampaignFormData(client, taskId, studentId);
    }
    console.log(results);
    try {
      const forms = await getForms(client, orderid, true);
      console.log(forms);
      let currentForm = 0;
      for (let i = 0; i < forms.length; i++) {
        if (formid === forms[i]) {
          currentForm = i;
          break;
        }
      }
      console.log(currentForm);
      let xfdf = '';
      if (refKey !== '') {
        const references = results[0].data.references;
        if (references && references !== null) {
          for (let i = 0; i < references.length; i++) {
            const reference = references[i];
            console.log('reference', reference);
            if (
              reference.key === refKey &&
              reference.forms &&
              reference.forms.formData
            ) {
              xfdf = reference.forms.formData[forms[currentForm]];
            }
          }
        }
      } else {
        if (taskId !== '') {
          if (results && results.forms) {
            xfdf = results.forms.formData[forms[currentForm]];
          }
        } else {
          if (results[0] && results[0].data && results[0].data.forms) {
            xfdf = results[0].data.forms.formData[forms[currentForm]];
          }
        }
      }
      console.log(xfdf);
      console.log('done');

      var host = `https://${client}`;
      if (process.env.NODE_ENV === 'development') {
        host = `http://${client}`;
      }

      const currentFormId = forms[currentForm];
      const content = await getDocumentArrayBuffer(
        `${host}/questions/form/${currentFormId}?orderid=${orderid}`
      );

      this.setState((state, props) => {
        return {
          client,
          currentForm,
          forms,
          finishedLoading: true,
          orderid,
          xfdf,
          currentFormId,
          content,
          host
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  async formCompleted(formid, xfdf) {
    // add formd data
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
    if (this.state.finishedLoading) {
      const title = `Form ${this.state.currentForm + 1} of ${
        this.state.forms.length
      }`;
      return (
        <div
          className="App"
          style={{
            backgroundColor: '#fff',
            maxWidth: '1170px',
            marginRight: 'auto',
            marginLeft: 'auto'
          }}
        >
          <img
            alt="form hero"
            src={this.state.host + '/casfiles/choice_fillableform_hero.png'}
          />
          {this.state.error && <div>{this.state.errorMessage}</div>}
          {this.state.finishedLoading && (
            <PSPDFKit
              documentId={this.state.currentForm}
              pdfUrl={this.state.content}
              licenseKey={licenseKey}
              baseUrl={baseUrl}
              completedForm={xfdf => {
                this.formCompleted(this.state.currentFormId, xfdf);
              }}
              hideToolbar={true}
              title={title}
              maxWidth="1170px"
              xfdf={this.state.xfdf}
            />
          )}
        </div>
      );
    }
    return null;
  }
}

export default ChoiceViewer;
